import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component"; // Import DataTable
import { baseurl, imageUrl } from "../../../Baseurl";
import AddMainCategory from "./AddMainCategory";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import AddMainCategorySub from "./AddMainCategorySub";



const AllMainSubCategory = () => {
  const [categories, setCategories] = useState([]);
  const [filterText, setFilterText] = useState(""); // Search input
  const [loading, setLoading] = useState(true); // Loading state

  // Fetch all categories from API
  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${baseurl}Getcat`);
      console.log("📂 Categories fetched:", response.data);
      setCategories(response.data.categories || []);
    } catch (error) {
      console.error("❌ Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  };

  // Load categories on component mount
  useEffect(() => {
    fetchCategories();
  }, []);




  // 🔹 Handle Delete Category
  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${baseurl}DeleteCategory/${id}`);
          setCategories(categories.filter((category) => category.id !== id)); // Update state
          Swal.fire("Deleted!", "Category has been deleted.", "success");
        } catch (error) {
          console.error("Error deleting category:", error);
          Swal.fire("Error!", "Failed to delete category.", "error");
        }
      }
    });
  };


  // Define table columns
  const columns = [
    {
      name: "#",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "60px",
    },
    {
        name: "Image",
        cell: (row) =>
          row.category_image ? (
            <img
              src={`${imageUrl}category/${row.category_image}`}
              alt={row.category_name}
              style={{ width: "50px", height: "auto", borderRadius: "5px" }}
            />
          ) : (
            "No Image"
          ),
      },
    {
      name: "Category Name",
      selector: (row) => row.category_name,
      sortable: true,
    },
    
    {
      name: "Status",
      selector: (row) => (row.status ? "Active" : "Inactive"),
      sortable: true,
    },
    {
      name: "Created At",
      selector: (row) => new Date(row.created_at).toLocaleDateString(),
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div>
          {/* Edit Button */}
          <Link 
            className="btn btnedit me-2"
             to="/"
          >
            <i className="fa fa-edit"></i>
          </Link>
  
          {/* Delete Button */}
          <Link
            className="btn btndelete"
            onClick={() => handleDelete(row.id)}
          >
            <i className="fa fa-trash"></i>
          </Link>
        </div>
      ),
      width: "150px",
      ignoreRowClick: true, // Prevent row click from triggering edit/delete
      allowOverflow: true, // Prevent overflow issues
      button: true, // Ensures proper button styling
    },
  ];
  

  // Filter categories based on search input
  const filteredCategories = categories.filter((category) =>
    category.category_name.toLowerCase().includes(filterText.toLowerCase())
  );

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <h4 className="mt-4">All Sub Categories</h4>
        <AddMainCategorySub/>
      </div>

      {/* Search Bar */}
      <div className="mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Search categories..."
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
        />
      </div>

      {/* DataTable Component */}
      <DataTable
        columns={columns}
        data={filteredCategories}
        pagination
        highlightOnHover
        progressPending={loading}
        noDataComponent="No categories found."  
      />
    </>
  );
};

export default AllMainSubCategory;
